<div class="marker-lined-block">
  <span class="marker" [style.borderColor]="markerColor ? markerColor : 'var(--primary)'"></span>
  <span class="line" [style.backgroundColor]="lineColor? lineColor : 'var(--gray300)'"></span>
  <ng-content></ng-content>
</div>